import React from 'react';
import { useNavigate } from 'react-router-dom';
import WingitPublicPage from './components/WingitPublicPage';
import WingitPanel from './components/WingitPanel';
import WingitButton from './components/WingitButton';
import wingitDesign from './designSystem';

export default function Register() {
  const navigate = useNavigate();

  return (
    <WingitPublicPage
      rightActionLabel="Log in"
      onRightAction={() => navigate('/login')}
    >
      <main style={styles.hero}>
        <h1 style={styles.title}>Welcome aboard.</h1>

        <p style={styles.subtitle}>
          Aircraft booking and flight operations for clubs, schools, syndicates and private owners.
        </p>

        <div style={styles.choiceGrid}>
          <WingitPanel style={styles.card}>
            <h2 style={styles.cardTitle}>Create organisation</h2>

            <p style={styles.cardText}>
              Start a new flying club, school, syndicate or private group.
            </p>

            <WingitButton onClick={() => navigate('/register-owner')}>
              Create organisation
            </WingitButton>
          </WingitPanel>

          <WingitPanel style={styles.card}>
            <h2 style={styles.cardTitle}>Join organisation</h2>

            <p style={styles.cardText}>
              Use the organisation code supplied by your owner or administrator.
            </p>

            <WingitButton variant="secondary" onClick={() => navigate('/join-organisation')} style={styles.secondaryActionButton}>
              Join organisation
            </WingitButton>
          </WingitPanel>
        </div>

        <div style={styles.loginPanel}>
          <div>
            <div style={styles.loginPanelTitle}>Already have an account?</div>
            <div style={styles.loginPanelText}>Log in to access your organisation.</div>
          </div>

          <button type="button" onClick={() => navigate('/login')} style={styles.secondaryButton}>
            Log in
          </button>
        </div>
      </main>
    </WingitPublicPage>
  );
}

const styles = {
  hero: {
    ...wingitDesign.publicPages.hero,
    maxWidth: 980,
  },

  title: {
    ...wingitDesign.publicPages.title,
    fontSize: '2.6rem',
  },

  subtitle: {
    ...wingitDesign.publicPages.subtitle,
    maxWidth: 660,
    fontSize: '1.08rem',
  },

  choiceGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '1.2rem',
    marginTop: '3rem',
  },

  card: {
    marginTop: 0,
  },

  cardTitle: {
    color: '#ffffff',
    fontSize: '1.2rem',
    fontWeight: 800,
    margin: 0,
  },

  cardText: {
    color: '#9fb6d1',
    fontSize: '0.98rem',
    lineHeight: 1.55,
    marginTop: '0.65rem',
    minHeight: 50,
  },

  secondaryActionButton: {
    width: '100%',
    borderRadius: 10,
    boxShadow: 'none',
  },

  loginPanel: {
    marginTop: '1.4rem',
    padding: '1rem',
    borderRadius: 14,
    background: 'rgba(255,255,255,0.03)',
    border: '1px solid rgba(255,255,255,0.075)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '1rem',
    flexWrap: 'wrap',
    textAlign: 'left',
  },

  loginPanelTitle: {
    color: '#ffffff',
    fontWeight: 800,
    fontSize: '1rem',
  },

  loginPanelText: {
    color: '#8fa8c5',
    marginTop: 3,
  },

  secondaryButton: {
    border: '1px solid rgba(85,199,255,0.24)',
    background: 'rgba(255,255,255,0.025)',
    color: '#d7ebff',
    borderRadius: 10,
    padding: '0.6rem 1.1rem',
    fontWeight: 700,
    cursor: 'pointer',
  },
};